import {Component, ElementRef, ViewChild} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: "app-singles",
  templateUrl: "./singles.component.html",
  styleUrls: ["./singles.component.scss"],
})
export class SinglesComponent {
  public albumListing: any = [];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public filter3: boolean = false;
  public filter1: boolean = true;
  public filter2: boolean = false;
  public tabType: any = "";
  public filterType: any = "";
  public filterTypeValue: any = "";
  public filterCTypeValue: any = "";
  public filtersTypeValue: any = "";
  public loading: boolean = false;
  public previousLabel: any = "";
  public nextLabel: any = "";
  public loginDetail: any = [];
  public cookingList: any = [];
  public dietList: any = [];
  public primaryList: any = [];
  public OrgList: any = [];
  public Views: boolean = false;
  public filetrOpenClose: boolean = false;
  public filetrArray:any=[];

  @ViewChild("filterIconLink") filterIconLink: ElementRef<HTMLElement>;

  constructor(public router: Router, public service: GlobalService) {
    this.loginDetail = getLocalJSON("grw_login");
    this.getAllMasterData();
    this.getData(1);
    this.getOrg();
  }

  ngOnInit(): void {}

  getItemThumbnail(item: any): string {
    if (!item) return 'assets/images/placeholder.svg';
    if (item.imgError) return 'assets/images/placeholder.svg';
    const thumb = item.thumbnail || '';
    if (!thumb || thumb.includes('1704990093505.png') || thumb.includes('cdn-dev.greatr.com.au')) {
      if (item.content && !item.content.endsWith('.mp4') && !item.content.includes('1704990093505.png')) {
        return item.content;
      }
    }
    return thumb || 'assets/images/placeholder.svg';
  }

  onImgError(item: any) {
    if (item) {
      item.imgError = true;
    }
  }

  getData(page: any) {
    this.loading = true;
    var url = "/single-post ";
    if(localStorage.getItem('grw_re')){
      this.tabType='7';
        setTimeout(() => {
        $('#pills-all-tab').removeClass(' active'); 
        $('#pills-share-tab').addClass(' active');
        localStorage.removeItem('grw_re');
      }, 100);
    }
    var detail = {
      page: page,
      status: this.tabType,
      category: this.filterTypeValue,
      type: this.filterType,
      section: this.filterCTypeValue,
      subsecction: this.filtersTypeValue,
    };
    this.service.PostApis(detail, url).subscribe(
      (response: any) => {
        if (response.success == 1) {
          response.data.record.filter((el: any) => {
            if (el.collaborator == undefined) {
              el.collaborator = [];
            } else {
              el.collaborator_name = el.collaborator[0].full_name;
            }
          });
          this.albumListing = response.data.record;
          this.totalCount = response.data.total;
          this.loading = false;
        } else {
          this.albumListing = [];
          this.loading = false;
        }
        if (response.is_video_free == false) {
          localStorage.setItem("grw_freevideo", "1");
        } else {
          localStorage.setItem("grw_freevideo", "0");
        }
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  redirect(data: any, type: any) {
    localStorage.setItem("grw_content_id", data._id);
    if (type == 1) {
      // if(data.is_video_added_on_album ==1 || data.is_video_added_on_program ==1){
      //   this.service.dangerAlert('Program or Album removed this post');
      // }
      this.router.navigate(["/edit-single-post"]);
    } else {
      this.router.navigate(["/video-detail"]);
    }
  }

  openList(type: any) {
    if (type == 1) {
      this.filter1 = false;
      this.filter2 = true;
      this.filter3 = false;
      setTimeout(() => {
        this.filterIconLink.nativeElement.click();
      }, 100);
    } else if (type == 3) {
      this.filter1 = true;
      this.filter2 = false;
      this.filter3 = false;
      setTimeout(() => {
        this.filterIconLink.nativeElement.click();
      }, 100);
    } else {
      this.filter2 = false;
      this.filter3 = true;
      this.filter2 = false;
      setTimeout(() => {
        this.filterIconLink.nativeElement.click();
      }, 100);
      this.filtersTypeValue = "";
    }
  }

  reset(type: any) {
    if (type == 1) {
      this.filterType = "";
      this.filterTypeValue = "";
      this.filterCTypeValue = "";
      this.filtersTypeValue = "";
    } else if (type == 2) {
      this.filterType = "";
      this.filterTypeValue = "";
      this.filterCTypeValue = "";
      this.filtersTypeValue = "";
      this.filter1 = true;
      this.filter2 = false;
      this.filter3 = false;
      this.filetrOpenClose = false;
    } else {
      this.filterType = "";
      this.filterTypeValue = "";
      this.filterCTypeValue = "";
      this.filtersTypeValue = "";
      this.filter2 = true;
      this.filter1 = false;
      this.filter3 = false;
    }
    this.getData(1);
  }

  redirectCheck() {
    const bypassProfileCheck = environment.bypassProfileCheck ?? false;
    if (bypassProfileCheck || this.loginDetail.profile_complete == true) {
      if (bypassProfileCheck || this.loginDetail.stripe_account_verify == true) {
        if(bypassProfileCheck || this.loginDetail.subscription_added==true){
          this.router.navigate(["/create-post"]);
        } else {
          $('#passlink11').trigger('click');
        }
      } else {
        $("#passlink11").trigger("click");
      }
    } else {
      $("#passlink11").trigger("click");
    }
  }

  getAllMasterData() {
    var self=this,ss:any=[],dd:any=[];
    const url = "/common-contents";
    this.service.GetApi(url).subscribe(
      (response: any) => {
        if (response.success == 1) {
          response.data.diet.filter((el: any) => {
            el.chcecked = false;

          });
          response.data.diet.filter((el:any)=>{
            if(el.childContent==false){
              ss.push(el);
            } else {
              dd=el;
            }
            el.chcecked = false;
          })
          ss.push(dd);
          response.data.diet =ss;
          ss=[],dd=[];
          response.data.cooking_times.filter((el:any)=>{
            if(el.childContent==false){
              ss.push(el);
            } else {
              dd=el;
            }
            el.chcecked = false;
          })
          ss.push(dd);
          response.data.cooking_times =ss;
          ss=[],dd=[];
          this.cookingList = response.data.cooking_times;
          this.dietList = response.data.diet;
          this.primaryList = response.data.sub_category;
        }
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  setval(event:any,val: any, type: any) {
    var self=this;
    if (type == 1) {
      this.filtersTypeValue = val;
      // console.log(typeof this.filtersTypeValue, "=", this.filtersTypeValue);
    } else {
      var jj:any=[]; self.filtersTypeValue='';
      if(event.target.checked){
        self.filetrArray.push(val);
        //  self.filetrArray.filter((el:any)=>{
        //   if(el !=val){
        //     jj.push(el);
        //   }
        // })
      } else {
        jj=[];
        self.filetrArray.filter((el:any)=>{
          if(el !=val){
            jj.push(el);
          }
        })
        self.filetrArray=jj;
      }
      if(self.filetrArray.length !=0){
        self.filetrArray.filter((el:any)=>{
          if (self.filtersTypeValue != "") {
          self.filtersTypeValue = self.filtersTypeValue + "," + el;
          } else {
            self.filtersTypeValue = el;
          }
        })
      }
    }
  }

  getOrg() {
    this.service
      .GetApi("/approved-collaborators")
      .subscribe((response: any) => {
        if (response.success) {
          this.OrgList = response.data;
        }
      });
  }

  setREvenue(event: any, id: any) {
    this.loading = true;
    var detail: any = {
      org_id: event.target.value,
      post_id: id,
    };
    this.service
      .PostApis(detail, "/single-post-share")
      .subscribe((response: any) => {
        if (response.success) {
          this.service.successAlert(response.message);
          this.loading = false;
          this.getData(1);
        } else {
          this.service.dangerAlert(response.message);
          this.loading = false;
        }
      });
  }

  RemoveREvenue(event: any, id: any) {
    this.loading = true;
    var detail: any = {
      org_id: event.target.value,
      post_id: id,
    };
    this.service
      .PostApis(detail, "/remove-single-post-share")
      .subscribe((response: any) => {
        if (response.success) {
          this.service.successAlert(response.message);
          this.loading = false;
          this.getData(1);
        } else {
          this.service.dangerAlert(response.message);
          this.loading = false;
        }
      });
  }

  callFilter() {
    if (this.filetrOpenClose) {
      this.filetrOpenClose = false;
      // $('#rrrr').show();
    } else {
      this.filetrOpenClose = true;
      // $('#rrrr').hide();
    }
  }

  changeFilter = (type: string) => {
    if (type == "filter1") {
      if (this.filterType == "" || this.filterType != "1") {
        this.filterType = 1;
      } else {
        this.filterType = "";
      }
    } else if (type == "filter2") {
      if (this.filterType == "" || this.filterType != "2") {
        this.filterType = 2;
      } else {
        this.filterType = "";
      }
    } else if (type == "filter3") {
      if (this.filterType == "" || this.filterType != "3") {
        this.filterType = 3;
      } else {
        this.filterType = "";
      }
    } else {
      this.filterType = "";
    }
  };

  getChaecks(event:any,type:any){
    var self=this;
    if(event.target.checked){
      $("#filtercheckbox"+type).prop("checked", false); 
      this.filterType='';
    } else {
      $("#filtercheckbox"+type).prop("checked", true); 
      this.filterType=type;
    }

    // this.genderList.filter((el:any)=>{
    //   if(el._id == event.target.id){
    //     if(el.chcecked==true){
    //       $("#"+event.target.id).prop("checked", false); 
    //       el.chcecked=false;
    //       self.albumData.controls['gender'].setValue('');
    //     } else {
    //       $("#"+event.target.id).prop("checked", true); 
    //       el.chcecked=true;

    //     }
    //   } else {
    //     el.checked=false;
    //   }
    // })
  }
}
